import type { Provider } from '@angular/core';
import { InjectionToken } from '@angular/core';

import { QUEST_ADAPTER, QUEST_ID, QuestStore } from '@app/core/quest';

import {
  APRIL_MADNESS_QUEST_ID,
  aprilMadnessParticipantsFactory,
  createAprilMadnessUserFallBack,
  mapQuestCalendarToAprilMadnessQuests,
  mapRafflesDataToAprilMadnessRaffles,
} from './april-madness-quest-helpers';

export const APRIL_MADNESS_QUEST_STORE = new InjectionToken<InstanceType<typeof QuestStore>>('APRIL_MADNESS_QUEST_STORE');

export function provideAprilMadnessQuestStore(): Provider[] {
  return [
    {
      provide: APRIL_MADNESS_QUEST_STORE,
      useExisting: QuestStore,
    },
    {
      provide: QUEST_ID,
      useValue: APRIL_MADNESS_QUEST_ID,
    },
    {
      provide: QUEST_ADAPTER,
      useValue: {
        mapQuestCalendarToQuests: mapQuestCalendarToAprilMadnessQuests,
        mapRafflesDataToRaffles: mapRafflesDataToAprilMadnessRaffles,
        createUserFallBack: createAprilMadnessUserFallBack,
        participantsFactory: aprilMadnessParticipantsFactory,
      },
    },
  ];
}
